import Rule from "../../Classes/Rule";
import { ruleViewerSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    currentRule: new Rule(),
    addModal: false,
    editModal: false
}

export default function ruleViewerSlice(state = initialState, action) {
    switch (action.type) {
        case ruleViewerSliceDispatch.setCurrentRule: {
            return {
                ...state,
                currentRule: action.payload
            }
        }
        case ruleViewerSliceDispatch.setAddModal: {
            return {
                ...state,
                addModal: action.payload
            }
        }
        case ruleViewerSliceDispatch.setEditModal: {
            return {
                ...state,
                editModal: action.payload
            }
        }
        case ruleViewerSliceDispatch.setIndexOverride: {
            return {
                ...state,
                indexOverride: action.payload
            }
        }
        case ruleViewerSliceDispatch.setRuleSearchResults: {
            return {
                ...state,
                ruleSearchResults: action.payload
            }
        }
        default:
            return state
    }
}
